import React     from 'react';
import { Link }  from 'react-router-dom';
import { WHATSAPP_URL, WHATSAPP_DISPLAY } from '../utils/constants';
import './Footer.css';

/* ── Inline icons (stroke inherits currentColor) ── */
const Icon: React.FC<{ d: string; filled?: boolean }> = ({ d, filled = false }) => (
  <svg width="16" height="16" viewBox="0 0 24 24"
       fill={filled ? 'currentColor' : 'none'}
       stroke={filled ? 'none' : 'currentColor'}
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);

const ICONS = {
  phone:  'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z',
  mail:   'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm18 2-10 7L2 6',
  clock:  'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-16v6l4 2',
  bag:    'M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0',
  wa:     'M12.04 2a9.9 9.9 0 0 0-8.4 15.2L2 22l4.96-1.6A9.9 9.9 0 1 0 12.04 2zm0 18.1a8.2 8.2 0 0 1-4.2-1.15l-.3-.18-2.94.95.96-2.87-.2-.3a8.2 8.2 0 1 1 6.68 3.55zm4.5-6.15c-.25-.12-1.46-.72-1.68-.8-.23-.09-.4-.13-.56.12-.17.25-.64.8-.79.97-.14.16-.29.18-.53.06a6.7 6.7 0 0 1-3.35-2.93c-.25-.43.25-.4.72-1.35.08-.16.04-.3-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.48c-.16 0-.43.06-.66.3-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.6.26 1.05.41 1.41.52.6.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.2-.58.2-1.07.14-1.18-.06-.1-.22-.16-.47-.28z',
  insta:  'M12 2c2.7 0 3.05.01 4.12.06 1.06.05 1.79.22 2.43.46.66.26 1.22.6 1.77 1.16.56.55.9 1.11 1.16 1.77.24.64.41 1.37.46 2.43.05 1.07.06 1.41.06 4.12s-.01 3.05-.06 4.12c-.05 1.06-.22 1.79-.46 2.43a4.9 4.9 0 0 1-1.16 1.77c-.55.56-1.11.9-1.77 1.16-.64.24-1.37.41-2.43.46-1.07.05-1.41.06-4.12.06s-3.05-.01-4.12-.06c-1.06-.05-1.79-.22-2.43-.46a4.9 4.9 0 0 1-1.77-1.16 4.9 4.9 0 0 1-1.16-1.77c-.24-.64-.41-1.37-.46-2.43C2.01 15.05 2 14.71 2 12s.01-3.05.06-4.12c.05-1.06.22-1.79.46-2.43.26-.66.6-1.22 1.16-1.77a4.9 4.9 0 0 1 1.77-1.16c.64-.24 1.37-.41 2.43-.46C8.95 2.01 9.29 2 12 2zm0 1.8c-2.67 0-2.99.01-4.04.06-.98.04-1.5.2-1.86.34-.46.18-.8.4-1.15.75-.35.35-.57.69-.75 1.15-.14.35-.3.88-.34 1.86-.05 1.05-.06 1.37-.06 4.04s.01 2.99.06 4.04c.04.98.2 1.5.34 1.86.18.46.4.8.75 1.15.35.35.69.57 1.15.75.35.14.88.3 1.86.34 1.05.05 1.37.06 4.04.06s2.99-.01 4.04-.06c.98-.04 1.5-.2 1.86-.34.46-.18.8-.4 1.15-.75.35-.35.57-.69.75-1.15.14-.35.3-.88.34-1.86.05-1.05.06-1.37.06-4.04s-.01-2.99-.06-4.04c-.04-.98-.2-1.5-.34-1.86a3.1 3.1 0 0 0-.75-1.15 3.1 3.1 0 0 0-1.15-.75c-.35-.14-.88-.3-1.86-.34-1.05-.05-1.37-.06-4.04-.06zm0 3.06a5.14 5.14 0 1 1 0 10.28 5.14 5.14 0 0 1 0-10.28zm0 1.8a3.34 3.34 0 1 0 0 6.68 3.34 3.34 0 0 0 0-6.68zm5.34-2.1a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z',
  fb:     'M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.51 1.5-3.9 3.78-3.9 1.09 0 2.24.2 2.24.2v2.46H15.2c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.89h-2.33v6.99A10 10 0 0 0 22 12z',
};

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-inner container">
      <div className="footer-brand">
        <div className="footer-logo">
          <img src="/logo.png" alt="Balaji Fashion House" />
          <div className="footer-logo-text">Balaji<br /><span>Fashion House</span></div>
        </div>
        <div className="footer-divider" />
        <p>Your destination for beautiful Indian ethnic wear. Quality kurtas, suits, palazzo sets and more — curated with love.</p>
        <a href={WHATSAPP_URL()} target="_blank" rel="noreferrer"
           className="btn-whatsapp footer-wa-btn">
          💬 Chat on WhatsApp
        </a>
      </div>

      <nav className="footer-links" aria-label="Footer navigation">
        <h4>Quick Links</h4>
        <Link to="/">Home</Link>
        <Link to="/products">All Products</Link>
        <Link to="/products/kurta">Kurtas</Link>
        <Link to="/products/suits">Suits</Link>
        <Link to="/products/palazzo-sets">Palazzo Sets</Link>
        <Link to="/products/velvet-collection">Velvet Collection</Link>
        <Link to="/contact">Contact Us</Link>
      </nav>

      <div className="footer-contact">
        <h4>Get in Touch</h4>
        <p><Icon d={ICONS.wa} filled /> <a href={WHATSAPP_URL()} target="_blank" rel="noreferrer">WhatsApp Us</a></p>
        <p><Icon d={ICONS.mail} /> <a href="mailto:balajifashioncollectionhouse@gmail.com">balajifashioncollectionhouse@gmail.com</a></p>
        <p><Icon d={ICONS.phone} /> <a href={`tel:${WHATSAPP_DISPLAY.replace(/\s/g, '')}`}>{WHATSAPP_DISPLAY}</a></p>
        <p><Icon d={ICONS.bag} /> Also on <a href="https://www.amazon.in" target="_blank" rel="noreferrer">Amazon India</a></p>
        <p><Icon d={ICONS.clock} /> Mon–Sat: 10am – 7pm</p>
        <div className="footer-social">
          <a href="https://www.instagram.com/balajifashionhousemhl/" target="_blank" rel="noreferrer" aria-label="Instagram" title="Instagram"><Icon d={ICONS.insta} filled /></a>
          <a href="https://www.facebook.com/balajifashioncollhouse"  target="_blank" rel="noreferrer" aria-label="Facebook" title="Facebook"><Icon d={ICONS.fb} filled /></a>
          <a href={WHATSAPP_URL()} target="_blank" rel="noreferrer" aria-label="WhatsApp" title="WhatsApp"><Icon d={ICONS.wa} filled /></a>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="container footer-bottom-inner">
        <span>© 2026 Balaji Fashion House. All rights reserved.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
